// Copyright (c) Move Closer 2023.

import { Component, Prop, Vue } from 'vue-property-decorator'

import { VariantSwitchConfig } from './VariantSwitch.config'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Component<VariantSwitchMixin>({
  name: 'VariantSwitchMixin'
})
export class VariantSwitchMixin extends Vue {
  @Prop({ type: Object, required: false, default: null })
  public readonly config!: VariantSwitchConfig
}
